import { render, staticRenderFns } from "./CategoriaEmpleado.vue?vue&type=template&id=b113b44a&scoped=true&"
import script from "./CategoriaEmpleado.vue?vue&type=script&lang=js&"
export * from "./CategoriaEmpleado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b113b44a",
  null
  
)

export default component.exports